import * as React from 'react';
import { Button } from '@mui/material';

const ArcGISAuth: React.FC = () => {
  const handleLogin = () => {
    window.location.href = '/api/auth/login';
  };

  return (
    <Button variant="contained" color="primary" onClick={handleLogin}>
      Log in with ArcGIS Online
    </Button>
  );
};

export default ArcGISAuth;
